export default function SlidePanel({ open, onClose, title, subtitle, children }) {
  return (
    <>
      <div className={`panel-overlay${open ? ' open' : ''}`} onClick={onClose} />
      <div className={`slide-panel${open ? ' open' : ''}`}>
        <div className="slide-panel-header">
          <div>
            <div className="slide-panel-title">{title}</div>
            {subtitle && <div className="slide-panel-sub">{subtitle}</div>}
          </div>
          <button
            onClick={onClose}
            style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 22, color: 'var(--muted)', lineHeight: 1, padding: '0 4px' }}
          >
            ×
          </button>
        </div>
        <div className="slide-panel-body">
          {children}
        </div>
      </div>
    </>
  );
}
